<template>
    <div class="mode_dialog">
        <el-dialog title="模式设置" :visible.sync="_modeDiaVisible" @closed='diaClose'>
            <div class="body_top">
                <span>生效范围: </span>
                <el-radio-group v-model="radio" @change=modeChange>
                    <el-radio :label="3">本模块</el-radio>
                    <el-radio :label="2">本题源</el-radio>
                    <el-radio :label="1">本地区</el-radio>
                    <el-radio :label="0">全平台</el-radio>
                </el-radio-group>
            </div>
            <div class="body_content">
                <div class="body_content_top">
                    <p>练习模式</p>
                </div>
                <div class="body_content_pratice">
                    <span>操作：</span>
                    <div>
                        <el-checkbox-group v-model="checkList" @change="checkChange">
                            <el-checkbox v-for="(item, index) in options" :key="index"
                                :label="item">{{ item }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="body_content_top">
                    <p>考试模式</p>
                </div>
                <div class="body_content_exam">
                    <p>模拟真实考试答题流程，不支持跳过</p>
                </div>
                <!-- <el-button plain size="small" @click="dialogSave">保存</el-button> -->
            </div>
            <el-button plain size="small" @click="dialogSave">保存</el-button>
            <div style="clear:both"></div>
        </el-dialog>
    </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import { saveoModeSetting,saveoRefiningModeSetting, getModeSetting } from "@/api/answeringProcess";
import { getRefiningModeSetting } from "@/api/answeringProcess";
export default {
    props: {
        modeDiaVisible: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        _modeDiaVisible: {
            get() {
                return this.modeDiaVisible
            },
            set(val) {
                console.log(val)
                this.$emit('update:modeDiaVisible', val)
            }
        }
    },
    mounted() {
        EventBus.$on('getBookAndRegion', this.getBookAndRegion)
    },
    data() {
        return {
            radio: 3,
            checkList: [],
            dialogForm: {},
            options: ['上一大题', '上一小题', '下一大题', '下一小题', '跳过', '我的回答', '重新回答', '提交'],
            bookId: '',
            regionId: '',
            catalogType: '',
            catalogId: ''
        }
    },
    methods: {
        diaClose() {

        },
        checkChange(val) {
            console.log(val)
        },
        dialogSave() {
            //模式设置必须要有模块类型参数值
            if (!this.catalogType) {
                this.$message.error('请选择模块类型！')
            } else {
                //对checklist进行排序
                let order = ['上一大题', '上一小题', '下一大题', '下一小题', '跳过', '我的回答', '重新回答', '提交'];
                let _checkList = this.checkList.sort((a,b)=>{
                    return order.indexOf(a) - order.indexOf(b)
                })
                let form = {
                    bookId: this.bookId,
                    regionId: this.regionId,
                    scope: this.radio,
                    examOperations: JSON.stringify([]),
                    testOperations: JSON.stringify(_checkList)
                }
                switch(this.$store.state.pageNum){
                    case "1":
                        form.type = this.catalogType;
                        saveoModeSetting(form).then(res => {
                            if (res.code == 0) {
                                this.$message.success('保存成功！')
                                //更新答题流程操作项目
                                EventBus.$emit('refreshModeSetting', true)
                            }
                        })
                        break;
                    case "2":
                        form.catalogId = this.$store.state.catalogId
                        saveoRefiningModeSetting(form).then(res => {
                            if (res.code == 0) {
                                this.$message.success('保存成功！')
                                //更新答题流程操作项目
                                EventBus.$emit('refreshModeSetting', true)
                            }
                        })
                        break
                }
                // let form = {
                //     bookId: this.bookId,
                //     regionId: this.regionId,
                //     scope: this.radio,
                //     examOperations: JSON.stringify([]),
                //     testOperations: JSON.stringify(_checkList),
                //     catalogType: this.catalogType
                // }
                // saveoModeSetting(form).then(res => {
                //     if (res.code == 0) {
                //         this.$message.success('保存成功！')
                //         //更新答题流程操作项目
                //         EventBus.$emit('refreshModeSetting', true)
                //     }
                // })
            }
            this.$emit('update:modeDiaVisible', false)
        },
        //查询数据库模式设置数据
        getModeSettingData(pageNum) {
            if (!this.catalogType) {
                this.$message.error('请选择模块类型！')
            } else {
                let query = {
                    bookId: this.bookId,
                    regionId: this.regionId,
                }
                switch(pageNum){    //pageNum=1为听说图书页面，pageNum=2为听说精练页面
                    case "1":
                        query.catalogType = this.catalogType
                        getModeSetting(query).then(res => {
                            this.deelModeData(res);
                        });
                        break;
                    case "2":
                        query.catalogId = this.catalogId;
                        getRefiningModeSetting(query).then(res => {
                            this.deelModeData(res);
                        });
                        break
                }
            }
        },
        deelModeData(res){  //统一对模式设置接口数据进行处理
            if (res.code == 0) {
                if (res.data) {
                    this.radio = parseInt(res.data.scope);
                    this.checkList = JSON.parse(res.data.testOperations)
                }
                this._modeDiaVisible = true
            }
        },
        //当前地区,书,模块信息
        getBookAndRegion(val) {
            this.bookId = val.bookId;
            this.regionId = val.regionId;
            this.catalogType = val.type;
            this.catalogId = val.catalogId;
            //将数据保存到vuex中
            this.$store.commit('updateRegionId', val.regionId);
            this.$store.commit('updatebookId', val.bookId);
            this.$store.commit('updateCatalogType', val.type);
            this.$store.commit('updateCatalogId', val.catalogId);
        },
        //模式选择生效范围切换拉取信息
        modeChange(scope) {
            let query = {
                bookId: this.bookId,
                regionId: this.regionId,
                scope: scope
            }
            switch(this.$store.state.pageNum){
                case "1":
                    query.catalogType = this.catalogType
                    getModeSetting(query).then(res => {
                        if (res.code == 0) {
                            if (res.data && res.data.testOperations.length > 0) {
                                this.checkList = JSON.parse(res.data.testOperations)
                            } else {
                                this.checkList = []
                            }
                        }
                    })
                    break;
                case "2":
                    query.catalogId = this.$store.state.catalogId
                    getRefiningModeSetting(query).then(res => {
                        if (res.code == 0) {
                            if (res.data && res.data.testOperations.length > 0) {
                                this.checkList = JSON.parse(res.data.testOperations)
                            } else {
                                this.checkList = []
                            }
                        }
                    })
                    break;
            }
            // let query = {
            //     bookId: this.bookId,
            //     regionId: this.regionId,
            //     catalogType: this.catalogType,
            //     scope: scope
            // }
            // getModeSetting(query).then(res => {
            //     if (res.code == 0) {
            //         if (res.data && res.data.testOperations.length > 0) {
            //             this.checkList = JSON.parse(res.data.testOperations)
            //         } else {
            //             this.checkList = []
            //         }
            //     }
            // })
        }
    },
    beforeDestroy() {
        EventBus.$off('getBookAndRegion', this.getBookAndRegion)
    },
}
</script>

<style lang="scss" scoped>
.mode_dialog {

    .body_top {
        span {
            margin-left: 13rem;
            font-size: 14rem;
        }

        .el-radio-group {
            margin-left: 13rem;
        }


        ::v-deep .el-radio__input .el-radio__inner {
            border-color: #A8ABB2;
        }

        ::v-deep .el-radio__label {
            color: #A8ABB2;
            font-size: 14rem;
        }

        ::v-deep .el-radio__input.is-checked .el-radio__inner {
            border-color: var(--primary-color);
            background: var(--primary-color);
        }

        ::v-deep .el-radio__input.is-checked+.el-radio__label {
            color: #303133;
        }
    }

    ::v-deep .el-dialog__body {
        padding-top: 15rem;
        padding-bottom: 15rem;
    }

    .body_content {
        width: 709rem;
        height: 283rem;
        background: #FFFFFF;
        margin-top: 20rem;
        border-radius: 8rem;
        border:1rem solid #e9e9e9;
        .body_content_top {
            height: 40rem;
            background: #D5FAE0;

            p {
                color: var(--primary-color);
                font-size: 16rem;
                margin-left: 13rem;
                line-height: 40rem;
            }
        }

        .body_content_pratice {
            display: flex;
            height: 105rem;
            align-items: center;

            span {
                font-size: 14rem;
                color: #000000;
                margin-left: 13rem;
                margin-top: -30rem;
                width: 10%;
            }

            .el-checkbox-group {
                display: inline;

                .el-checkbox {
                    width: 25%;
                    margin: 5rem 10rem 5rem -15rem;

                }
            }

            ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #FFB802;
                border-color: #FFB802;
            }

            ::v-deep .el-checkbox__input .el-checkbox__inner:hover,
            ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
                border-color: #FFB802;
            }

            ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #303133;
                font-size: 14rem;
            }

            ::v-deep .el-checkbox__label {
                color: #A8ABB2;
                ;
            }
        }

        .body_content_exam {
            color: #666666;
            font-size: 14rem;
            padding-left: 13rem;
            height: 100rem;
            display: flex;
            align-items: center;
        }

        
    }
    .el-button {
            background: var(--primary-color);
            width: 76rem;
            height: 32rem;
            border-radius: 6rem;
            border-color: var(--primary-color);
            color: #FFFFFF;
            float: right;
            margin-top: 14rem;
            padding: 0;
        }
}

::v-deep .el-dialog {
    border-radius: 10rem;
    width: 749rem;
    // height: 460rem;
    background: #f5f5f5;

}

::v-deep .el-dialog__title {
    font-size: 18rem;
    color: #333333;
    padding-left: 13rem;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 5rem;
        height: 20rem;
        border-radius: 10rem;
        background-color: var(--primary-color);
    }
}
</style>